import { render, staticRenderFns } from "./cms-block-faq-item.vue?vue&type=template&id=5220805c&scoped=true"
import script from "./cms-block-faq-item.vue?vue&type=script&lang=js"
export * from "./cms-block-faq-item.vue?vue&type=script&lang=js"
import style0 from "./cms-block-faq-item.vue?vue&type=style&index=0&id=5220805c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220805c",
  null
  
)

export default component.exports